import React from 'react'

import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

import TranslationHelper from '../../helpers/helper-translation'

const SearchCard = ({ filter, toggleFilterVisibility, onSearch }: IProps) => (
  <S.Container>
    <S.SearchSvg>
      <Icon
        name="search"
        widht={24}
        height={24}
        onClick={() => onSearch(filter)}
      />
    </S.SearchSvg>
    <S.Content>
      <S.Specialties>{filter.specialties.join(', ')}</S.Specialties>
      <S.OthersFilters>
        <S.Filter>
          {filter.locations
            .map((location) => location.cities)
            .flat()
            .join(', ')}
        </S.Filter>
        <S.CircleDivisor />
        <S.Filter>
          {Object.entries(filter.availability)
            .filter(([, availabilityState]) => availabilityState.selected)
            .map(([day]) => TranslationHelper.translateDay(day))
            .join(', ')}
        </S.Filter>
      </S.OthersFilters>
    </S.Content>
    <Icon
      name="filter"
      widht={24}
      height={24}
      onClick={toggleFilterVisibility}
    />
  </S.Container>
)

export default SearchCard
